import { useState, useEffect } from 'react';
import Icon from '../../../components/AppIcon';

const ThemeToggle = () => {
  const [isDark, setIsDark] = useState(false);

  useEffect(() => {
    const isDarkMode = document.documentElement?.classList?.contains('dark');
    setIsDark(isDarkMode);
  }, []);

  const toggleTheme = () => {
    const newTheme = !isDark;
    setIsDark(newTheme);
    document.documentElement?.classList?.toggle('dark');
  };

  return (
    <button
      onClick={toggleTheme}
      className="relative inline-flex h-10 w-20 items-center rounded-full transition-colors duration-250 focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2"
      style={{
        backgroundColor: isDark ? 'var(--color-primary)' : 'var(--color-muted)'
      }}
      role="switch"
      aria-checked={isDark}
      aria-label={`Switch to ${isDark ? 'light' : 'dark'} mode`}
    >
      <span
        className="inline-flex h-8 w-8 items-center justify-center transform rounded-full bg-background shadow-md transition-transform duration-250"
        style={{
          transform: isDark ? 'translateX(2.5rem)' : 'translateX(0.25rem)'
        }}
      >
        <Icon
          name={isDark ? 'Moon' : 'Sun'}
          size={16}
          color={isDark ? 'var(--color-primary)' : 'var(--color-muted-foreground)'}
        />
      </span>
    </button>
  );
};

export default ThemeToggle;